import { getIsCompanyManaged, getRapidViewId } from '../../state/selectors/app';
import type { State } from '../../state/types';

export interface ServiceContext {
	boardId: string;
	isCompanyManaged: boolean;
}

export function makeServiceContext(state: State): ServiceContext {
	return {
		boardId: getRapidViewId(state),
		isCompanyManaged: getIsCompanyManaged(state),
	};
}
